import { Suspense } from 'react';

import { lazyRoute } from 'src/routes/lazy-route';
import { Outlet } from 'react-router-dom';
// components
import { SplashScreen } from 'src/components/loading-screen';

import ExciseReportPage from 'src/pages/public/excise-report';
import { paths } from '../paths';

// ----------------------------------------------------------------------

// Lazy load the DownloadProductsPage component
const DownloadProductsPage = lazyRoute(() => import('src/pages/public/download-products'));
const DownloadGenericProductsPage = lazyRoute(
  () => import('src/pages/public/download-generic-products'),
);

// ----------------------------------------------------------------------

export const downloadRoutes = [
  {
    path: paths.root,
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: paths.public.downloadProducts(':token'),
        element: <DownloadProductsPage />,
      },
      {
        path: paths.public.generic,
        element: <DownloadGenericProductsPage />,
      },
      {
        path: 'excise-report',
        element: <ExciseReportPage />,
      },
    ],
  },
];
